// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"9d1d3a0f","560":"ac054162"}[chunkId] + ".chunk.js";
};